import api from '../services/api';
import apiWithJwt from '../services/apiWithJwt';
import { types } from '../store/constants/types';


export const emptyRedux = () => {
  return dispatch => {
    dispatch({type : types.GET_PAYMENT_SETTING_FAILED, payload : []})
    dispatch({type : types.GET_ALL_PAYMENT_SETTINGS_FAILED, payload : []})
    dispatch({type : types.UPDATE_PAYMENT_SETTING_FAILED, payload : []})
    dispatch({type : types.UPDATE_WHATSAPP_SETTINGS_FAILED, payload : []})
  }
}


export const resetGetPaymentSetting = () => {
  return dispatch => {
    dispatch({type : types.GET_PAYMENT_SETTING_SUCCESS, payload : []})
}};

export const getAllPaymentSetting = () => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/settings/payments/')
      .then((response) => {
        dispatch({ type: types.GET_ALL_PAYMENT_SETTINGS_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_ALL_PAYMENT_SETTINGS_FAILED, payload: (error.response.data)});
      });
  };
};

export const resetgetAllPaymentSetting = () => {
  return dispatch => {
    dispatch({type : types.GET_ALL_PAYMENT_SETTINGS_SUCCESS, payload : []})
}};


export const resetUpdatePaymentSetting = () => {
  return dispatch => {
     dispatch({type : types.UPDATE_PAYMENT_SETTING_SUCCESS, payload : []})
}};

export const getWhatsappSettings = () => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/settings/whatsapp/')
      .then((response) => {
        dispatch({ type: types.GET_WHATSAPP_SETTINGS_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_WHATSAPP_SETTINGS_FAILED, payload: (error.response.data)});
      });
  };
};

export const updateWhatsappSettings = (data) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.put('/settings/whatsapp/update', data)
      .then((response) => {
        dispatch({ type: types.UPDATE_WHATSAPP_SETTINGS_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_WHATSAPP_SETTINGS_FAILED, payload: (error.response.data)});
      });
  };
};

export const getPaymentSetting = () => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.get('/settings/payments/')
      .then((response) => {
        dispatch({ type: types.GET_PAYMENT_SETTING_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.GET_PAYMENT_SETTING_FAILED, payload: (error.response.data)});
      });
  };
};

export const updatePaymentSetting = (data, id) => {
  return (dispatch) => {
    const apiWithToken = apiWithJwt(localStorage.token);
    apiWithToken.put('/settings/payment/update/'+id, data)
      .then((response) => {
        dispatch({ type: types.UPDATE_PAYMENT_SETTING_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_PAYMENT_SETTING_FAILED, payload: (error.response.data)});
      });
  };
};
